import React, { useState, useEffect } from "react";
import { Table, Image, Button } from "react-bootstrap";
import ReactStars from "react-rating-stars-component";
import moment from "moment";
import BasicPagination from "../../../../Pagination/Pagination";
import HideMessage from "./HideMessage";
import ReviewDetails from "./ReviewDetails";
import ViewLikeDislikeReview from "./ViewLikeDislikeReview";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { viewAllReviews } from "../../../../../store/actions/SuperAdminActions/commonSuperAdmin";
import { SmallLoader } from "../../../../Loader/SmallLoader";
import isEmpty from "../../../../../store/validation/is-Empty";

const SeatingRatingReview = (props) => {
  //state  //
  const [loading, setLoading] = useState(false);
  const [filterValue, setFilterValue] = useState();
  const [page, setPage] = useState(1);
  const [showView, setShowView] = useState(false);
  const [showViewLikeDislike, setShowViewLikeDislike] = useState(false);

  const [review, setReview] = useState();
  const handleShowView = (review) => {
    setReview(review);
    setShowView(true);
  };
  const handleCloseView = () => setShowView(false);
  const handleShowViewLikeDislike = (review) => {
    setReview(review);
    setShowViewLikeDislike(true);
  };
  const handleCloseViewLikeDislike = () => setShowViewLikeDislike(false);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };
  const onSuccessReviews = () => {
    setLoading(false);
  };
  const onErrorReviews = () => {
    setLoading(false);
  };
  var filterType = "";
  useEffect(() => {
    setLoading(true);
    const token = props.auth.user.accessToken;
    if (props.insidePageTab === 1) {
      filterType = "NEW";
      setFilterValue("NEW");
    } else if (props.insidePageTab === 2) {
      filterType = "HIDDEN";
      setFilterValue("HIDDEN");
    } else {
      filterType = "ALL";
      setFilterValue("ALL");
    }
    props.viewAllReviews(
      token,
      "SEATING",
      filterType,
      1,
      onSuccessReviews,
      onErrorReviews,
      moment().format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    );
  }, [props.insidePageTab]);

  useEffect(() => {
    const token = props.auth.user.accessToken;
    if (!isEmpty(props.dateQueryProps)) {
      props.viewAllReviews(
        token,
        "SEATING",
        filterType,
        1,
        onSuccessReviews,
        onErrorReviews,
        props.dateQueryProps.startDate,
        props.dateQueryProps.endDate
      );
    }
  }, [props.dateQueryProps, props.insidePageTab]);

  useEffect(() => {
    setPage(1);
    setStart(0);
    setEnd(10);
  }, [props.search, props.location, props.rating, props.startDate]);

  const [reviews, setReviews] = useState([]);
  var filteredReviews = reviews.filter((review) => {
    return (
      (review.review !== undefined &&
        review.review !== null &&
        review.review.toLowerCase().includes(props.search)) ||
      (review &&
        review.restaurant_id &&
        review.restaurant_id.restaurant_name
          .toLowerCase()
          .includes(props.search)) ||
      (review &&
        review.user_id &&
        review.user_id.first_name.toLowerCase().includes(props.search))
    );
  });

  if (props.location) {
    filteredReviews = filteredReviews.filter((review) => {
      return (
        review &&
        review.restaurant_id &&
        review.restaurant_id.city.toLowerCase().includes(props.location)
      );
    });
  }

  if (props.rating) {
    filteredReviews = filteredReviews.filter((review) => {
      return review && review.rating === props.rating;
    });
  }

  if (props.startDate !== "" && props.endDate !== "") {
    filteredReviews = filteredReviews.filter(
      (item) =>
        moment(item.createdAt).format("X") >=
          moment(props.startDate).format("X") &&
        moment(item.createdAt).format("X") <= moment(props.endDate).format("X")
    );
  }

  if (props.sortFilter === "A-Z") {
    filteredReviews = filteredReviews.sort((a, b) => {
      if (
        a?.user_id?.first_name + " " + a?.user_id?.last_name <
        b?.user_id?.first_name + " " + b?.user_id?.last_name
      )
        return -1;
      if (
        a?.user_id?.first_name + " " + a?.user_id?.last_name >
        b?.user_id?.first_name + " " + b?.user_id?.last_name
      )
        return 1;
      return 0;
    });
  }
  if (props.sortFilter === "Z-A") {
    filteredReviews = filteredReviews.sort((a, b) => {
      if (
        a?.user_id?.first_name + " " + a?.user_id?.last_name <
        b?.user_id?.first_name + " " + b?.user_id?.last_name
      )
        return 1;
      if (
        a?.user_id?.first_name + " " + a?.user_id?.last_name >
        b?.user_id?.first_name + " " + b?.user_id?.last_name
      )
        return -1;
      return 0;
    });
  }

  useEffect(() => {
    if (props.data.length !== filteredReviews.length) {
      props.setDataa(filteredReviews);
    }
  }, [filteredReviews]);

  useEffect(() => {
    if (props.allReviews) {
      const items = props.allReviews;
      const reversedItems = items.map((item) => item).reverse();
      setReviews(reversedItems);
    }
  }, [props.allReviews]);
  
  useEffect(() => {
    if (props.data.length !== filteredReviews.length) {
      props.setDataa(filteredReviews);
    }
  }, [filteredReviews]);

  return (
    <React.Fragment>
      <div className="user-table-reusable-superadmin table-responsive">
        <Table className="HideShowTable enMinWidth900">
          <thead>
            <tr className="super_admin_all_users_table_head">
              <th style={{ width: "13%" }} className="f12-700">
                Restaurant /<br />
                Location
              </th>
              <th style={{ width: "12%" }} className="f12-700">
                User Name
              </th>
              <th style={{ width: "15%" }} className="f12-700">
                Ratings-
                <br />
                Date & Time
              </th>
              <th style={{ width: "25%" }} className="f12-700">
                Review Comment
              </th>
              <th style={{ width: "15%" }} className="f12-700">
                Request Type /<br />
                Order ID
              </th>
              <th style={{ width: "20%" }} className="f12-700">
                Action
              </th>
            </tr>
          </thead>
          {props.auth.secondary_loader ? (
            <SmallLoader />
          ) : (
            filteredReviews &&
            filteredReviews.slice(start, end).map((review, index) => (
              <tbody key={index}>
                {/* enLeftGReenLine */}
                <tr className="enLeftYellowLine super_admin_all_users_table_body">
                  <td style={{ width: "calc(13% - 5px)" }}>
                    <div className="d-flex flex-column align-items-start">
                      <div className="enImage45">
                        <Image
                          //src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                          src={
                            review &&
                            review.restaurant_id &&
                            review.restaurant_id.logo_url
                          }
                          alt="restaurant logo"
                          title="restaurant logo"
                          fluid
                          width="100%"
                          height="100%"
                        />
                      </div>
                      <div className="f11-500 mt-1">
                        {review &&
                          review.restaurant_id &&
                          review.restaurant_id.restaurant_name}
                      </div>
                      <div className="f10-400">
                        {review &&
                          review.restaurant_id &&
                          review.restaurant_id.city}
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "12%" }}>
                    <div className="d-flex align-items-center justify-content-start">
                      <div className="d-flex flex-column align-items-center justify-content-center">
                        <div className="super-admin-suggestion-imageBoxOne enImage45 rounded-circle">
                          {review &&
                          review.user_id &&
                          review.user_id.profile_photo[0] ? (
                            <Image
                              fluid
                              //src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                              src={review.user_id.profile_photo[0]}
                              alt="Icon"
                            />
                          ) : (
                            <Image
                              fluid
                              src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                              //src={review.user_id.photos[0]}
                              alt="Icon"
                            />
                          )}
                        </div>
                        <div className="super-admin-suggestion-imageBoxTwo mt-2">
                          <div className="f12-400">
                            {" "}
                            {review &&
                              review.user_id &&
                              review.user_id.first_name}{" "}
                            {review &&
                              review.user_id &&
                              review.user_id.last_name}{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="f12-400 mb-1">{review.rating} Stars</div>
                    <ReactStars
                      count={5}
                      value={review.rating}
                      edit={false}
                      size={22}
                      half={true}
                      emptyIcon={<i className="fa fa-star-o"></i>}
                      halfIcon={<i className="fa fa-star-half-alt"></i>}
                      fullIcon={<i className="fa fa-star"></i>}
                      color2={"#FDD400"}
                    />
                    <div className="f10-400 mt-1">
                      {moment(review.createdAt).format("Do MMM YYYY")}
                    </div>
                    <div className="f10-400 mt-1">
                      {moment(review.createdAt).format("hh:mm A")}
                    </div>
                  </td>
                  <td style={{ width: "25%" }}>
                    <div className="rating-review-table-body-sectiontwo ">
                      <span className="f12-400 enEllips3">{review.review}</span>
                      <Button
                        className="f12-400 text-red p-0"
                        variant="link"
                        onClick={() => handleShowView(review)}
                      >
                        Read More
                      </Button>
                      <div className="d-flex align-items-center pt-2">
                        <div
                          className="d-flex align-items-center cursor"
                          onClick={() => handleShowViewLikeDislike(review)}
                        >
                          <div>
                            <Image
                              fluid
                              alt="User Photo"
                              width="14px"
                              src={require("../../../../../assets/images/superadmin/like.svg")}
                            />
                          </div>
                          <div className="rating-review-table-body-usertextone">
                            <div className="f10-400 mt-1 mx-2">
                              {" "}
                              {review.likes.length}
                            </div>
                          </div>
                        </div>

                        <div
                          className="d-flex align-items-center cursor"
                          onClick={() => handleShowViewLikeDislike(review)}
                        >
                          <div>
                            <Image
                              fluid
                              alt="User Photo"
                              width="14px"
                              src={require("../../../../../assets/images/superadmin/disslike.svg")}
                            />
                          </div>
                          <div className="rating-review-table-body-usertextone">
                            <div className="f10-400 mt-1 mx-2">
                              {" "}
                              {review.dislikes.length}
                            </div>
                          </div>
                        </div>

                        <div
                          className="d-flex align-items-center cursor"
                          onClick={() => handleShowViewLikeDislike(review)}
                        >
                          <div>
                            <Image
                              fluid
                              alt="User Photo"
                              width="14px"
                              src={require("../../../../../assets/images/superadmin/chat.svg")}
                            />
                          </div>
                          <div className="rating-review-table-body-usertextone">
                            <div className="f10-400 mt-1 mx-2">
                              {review.comment.length}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="d-flex align-items-center">
                      <div className="image-box-new mr-2">
                        <Image
                          fluid
                          src={require("../../../../../assets/images/seatingImages/reservationBlack.png")}
                        />
                      </div>
                      <div>
                        <div className="f12-500">
                          {review.diner_id && review.diner_id.service_type}
                        </div>
                        <span className="f10-400">
                          {review.diner_id && review.diner_id._id}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "20%" }}>
                    <div className="d-flex align-items-center mt-3">
                      <div>
                        <HideMessage
                          reviewId={review._id}
                          hideStatus={review.status}
                          filterValue={filterValue}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            ))
          )}
        </Table>
      </div>
      {filteredReviews.length !== 0 ? (
        <BasicPagination
          totalRecords={filteredReviews.length}
          limit={10}
          batch={page}
          onBatchChange={(e) => handleBatchChange(e)}
        />
      ) : (
        <> </>
      )}
      <ReviewDetails
        handleCloseView={handleCloseView}
        review={review}
        showView={showView}
      />
      <ViewLikeDislikeReview
        handleCloseView={handleCloseViewLikeDislike}
        showView={showViewLikeDislike}
        review={review}
      />
    </React.Fragment>
  );
};

SeatingRatingReview.propTypes = {
  auth: PropTypes.object.isRequired,
  viewAllReviews: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  allReviews: state.commonSuperAdmin.allReviews.data,
});

export default connect(mapStateToProps, {
  viewAllReviews,
})(SeatingRatingReview);
